import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
interface StickyMobileCTAProps {
  onCtaClick: () => void;
}
export function StickyMobileCTA({
  onCtaClick
}: StickyMobileCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past roughly the hero section (e.g., 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-142">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-white/80 backdrop-blur-md border-t border-zen-beige z-40 md:hidden" data-id="element-143">
          <button onClick={onCtaClick} className="w-full bg-pistachio text-slate-dark font-bold py-4 px-6 rounded-full shadow-lg active:scale-95 transition-transform" data-id="element-144">
            OBTENER PROTOCOLO — $4.990
          </button>
        </motion.div>}
    </AnimatePresence>;
}